import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';

export enum CardBrand {
	AmericanExpress = 'american-express',
	CartesBancaires = 'cartes-bancaires',
	Cirrus = 'cirrus',
	Discover = 'discover',
	DinersClub = 'diners-club',
	Elo = 'elo',
	Hipercard = 'hipercard',
	Jcb = 'jcb',
	Maestro = 'maestro',
	Mastercard = 'master-card',
	Mir = 'mir',
	UnionPay = 'union-pay',
	Visa = 'visa',
}

export enum PaymentMethodType {
	Unknown = 'unknown',
	Card = 'card',
	Visa = 'visa',
	MasterCard = 'master-card',
	AmericanExpress = 'amex',
	ApplePay = 'apple-pay',
	GooglePay = 'google-pay',
	Swish = 'swish',
	ACH = 'ach',
	MBWay = 'mbway',
	Trustly = 'trustly',
	PayByBank = 'pay-by-bank',
}

export interface PaymentMethodData {
	lastFourDigits: string;
	expirationMonth: number;
	expirationYear: number;
	cardBrand: CardBrand;
}

export interface PaymentMethod extends AllowedActionable {
	id: number;
	userId: number;
	groupPaymentConfigId: number;
	groupPaymentConfigPaymentMethodId: number;
	paymentProviderId: string;
	paymentMethodType: PaymentMethodType;
	paymentMethodData: PaymentMethodData;
	description: string;
	createdAt?: number;
	disabledAt?: number;
	archivedAt?: number;
}
